import { AttributesMixin, define } from "@type-r/models";
import { CountsModel } from "./countsModel";
import { restfulIO } from "./endpoint";

export interface InvoiceCount extends AttributesMixin<typeof InvoiceCount> { }
@define
export class InvoiceCount extends CountsModel {
    static endpoint = restfulIO('api/v1/ingest/invoices/counts');

    static attributes = {
        ...CountsModel.attributes
    };

}
